import { useEffect, useState } from 'react';
import { PersistGate as ReduxPersistGate, PersistGateProps as ReduxPersistGateProps } from 'redux-persist/integration/react';

export interface PersistGateProps extends ReduxPersistGateProps {
  isSSR?: boolean;
}

export const PersistGate = ({ children, isSSR, ...props }: PersistGateProps) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    if (isSSR) {
      return children;
    }
    return null;
  }

  return <ReduxPersistGate {...props}>{children}</ReduxPersistGate>;
};

export default PersistGate;
